import { ConfigFn } from '@config/types'

const config = (({ publication }) =>
  ({
    dataPrivacyUrl: `${
      publication === 'romandie'
        ? '/fr/services/dispositions-de-protection-des-donnees-id18211424.html'
        : '/services/datenschutz-bestimmungen-id17911013.html'
    }#cmpOpener`,
    dataPrivacyPolicyUrl: `${
      publication === 'romandie'
        ? '/fr/services/conditions-generales-d-utilisation-du-groupe-blick-id16443050.html'
        : '/services/datenschutz-bestimmungen-id17911013.html'
    }`,
    agbUrl: `${
      publication === 'romandie'
        ? '/fr/services/dispositions-de-protection-des-donnees-id18211424.html'
        : '/services/allgemeine-nutzungsbedingungen-id158845.html'
    }`,
  }) as const) satisfies ConfigFn

export default config
